/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllApplication, getAppHistory } from './applicationAction';

const initialState = {
    data: {},
    applications: {},
    applicationHistory: {}
}
const applicationSlice = createSlice({
    name: 'application',
    initialState,
    extraReducers: {

        [getAllApplication.fulfilled]: (state, { payload }) => {
            state.applications = payload;
        },
        [getAppHistory.fulfilled]: (state, { payload }) => {
            state.applicationHistory = payload;
        },
        [getAppHistory.rejected]: (state, action) => {
            state.applicationHistory = {};
        },
    }
});

export default applicationSlice.reducer